<template>
  <div class="minigame">
    <div class="loading" v-if="!desktoploaded && !mobileloaded">
      <img class="loading" :src="loading">
    </div>
    <div class="container-fluid trygame" :style="'background-color:'+game.bgColor">
      <!--            <div class="main" :style="'background-image: url('+ tryGameBg +');'">-->
      <div class="main">
        <div class="ani desktop" :id="'lottiedesktop'"></div>
        <div class="ani mobile" :id="'lottiemobile'"></div>
        <div class="left leftGradient"></div>
        <div class="right rightGradient"></div>
        <div class="content">
          <div class="title">
            <img :src="tryGameLogo" alt="">
          </div>
          <div class="info">
            <div class="device">
              <div class="subtitle upper">DEVICE</div>
              <div class="options">
                <img v-for="(type,i) in game.size" v-if="(device=='desktop' || i =='mobile' )" :src="'images/icon/'+i+((i==uiType)?'-active':'')+'.png'" alt="" @click="changeUI(i)">
              </div>
            </div>
            <div class="language">
              <div class="subtitle upper">LANGUAGE</div>
              <div class="options">
                <img v-for="lg in languages" :src="'images/icon/'+lg+'_icon'+((lg==lang)?'':'_gray')+'.png'" alt="" @click="changeLG(lg)">
              </div>
            </div>
          </div>
          <div class="try-btn upper" @click="getUrl">
            <img :src="tryGameBtn" alt="">
            <span v-text="'Play Demo'" :style="'color:'+this.game.btnTextColor"></span>
          </div>
        </div>
      </div>
    </div>

    <div class="container gameinfo">
      <div class="row main">
        <div class="top">
          <img :src="iconImg" alt="" class="icon">
          <span class="mobile title upper" v-text="game.name"></span>
        </div>
        <div class="info">
          <span class="web title upper" v-text="game.name"></span>
          <span class="desc" v-html="game.description"></span>
        </div>
      </div>
      <div class="row gt">
        <div class="item">
          <div class="title upper">GAME TYPE</div>
          <div class="content">
            <img class="gametype" :src="'images/icon/'+game.info.gameType+'.png'" alt="">
          </div>
        </div>
        <div class="item">
          <div class="title upper">FULL SIZE</div>
          <div class="content">
            <span class="number" v-text="game.info.fullSize.number"></span>
            <span class="type" v-text="game.info.fullSize.type"></span>
          </div>
        </div>
        <div class="item">
          <div class="title upper">INITIAL DOWNLOAD</div>
          <div class="content">
            <span class="number" v-text="game.info.inital.number"></span>
            <span class="type" v-text="game.info.inital.type"></span>
          </div>
        </div>
      </div>
      <div class="row gt icons">
        <div class="item">
          <div class="title upper">COMPATIBLE WITH</div>
          <div class="content compatible">
            <img class="icon" v-for="i in game.info.compatible" :src="'images/icon/'+i+'_icon.png'" alt="">
          </div>
        </div>
        <div class="item">
          <div class="title upper">LANGUAGE</div>
          <div class="content language">
            <img class="icon" v-for="i in game.info.language" :src="'images/icon/'+i+'_icon.png'" alt="">
          </div>
        </div>
        <div class="item"></div>
      </div>
    </div>
    <div class="other">
      <div class="container">
        <div class="title">OTHER GAMES</div>
        <carousel :type="'minigame'" :name="this.$route.params.game"></carousel>
      </div>
    </div>
  </div>
</template>

<script>
import carousel from '@/components/Game/detail/carousel'
import animationData from '@/assets/data.json'
import loading from "@/assets/Aloading.gif";

export default {
  name: "aeongame",
  components: {carousel},
  data: function () {
    return {
      loading: loading,
      desktoploaded: false,
      mobileloaded: false,
      url: '',
      uiType: 'mobile',
      lang: 'en',
      clientWidth: 0,
      languages: ['en', 'cn'],
      device: this.$dataManager.getDevice(),
      gamePop: null
    }
  },
  computed: {
    game() {
      return this.$dataManager.findGameByName(this.$route.params.game)
    },
    route() {
      return this.$route.params.game
    },
    tryGameBg: function () {
      var url
      if (this.clientWidth > 630) {
        url = 'images/game/' + this.$route.params.game + '/trygame_banner.png';
      } else {
        url = 'images/game/' + this.$route.params.game + '/trygame_banner_mobile.png';
      }
      return url
    },
    tryGameLogo: function () {
      var url = 'images/game/' + this.$route.params.game + '/trygame_logo.png';
      return url
    },
    tryGameBtn: function () {
      var url = 'images/game/' + this.$route.params.game + '/trygame_btn.png';
      return url
    },
    iconImg: function () {
      var url = 'images/game/' + this.$route.params.game + '/mini_icon.png';
      return url
    },
  },
  methods: {
    getWidth: function () {
      this.clientWidth = parseInt(document.querySelector('.trygame').offsetWidth)
    },
    changeUI: function (i) {
      this.uiType = i
    },
    changeLG: function (i) {
      this.lang = i
    },
    getUrl: function () {
      const dateTime = Date.now();
      const timestamp = Math.floor(dateTime / 1000);
      const random = this.getRandom(1000, 9999)
      const thisDevice = this.$dataManager.getDevice()
      const type = this.$dataManager.findGamesType(this.game.gameId)

      var d = (this.uiType === 'desktop') ? 1.7118 : 1.975
      const size = {
        height: ((window.screen.width * 0.4) / d),
        width: window.screen.width * 0.4
      }
      let uId = timestamp + random
      const _config = 'height=' + (size.height + 10) + ',width=' + size.width + ',toolbar=no,menubar=no,scrollbars=no,resizable=no'

      var url = this.$router.resolve({
        name: 'demo',
        params: {type: type, width: size.width, height: size.height, device: thisDevice, gameCode: this.game.gameId, uId: uId, uiType: this.uiType, lang: this.lang}
      })

      this.gamePop = window.open(url.href, 'Demo Game', _config);
    },
    getRandom: function (min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    getDomDCSS() {
      var dom = document.getElementById('gradient');
      if (!dom) {
        dom = document.createElement('style');
        var head = document.head || document.querySelector("head") || document.getElementsByTagName("head")[0];
        dom.type = 'text/css';
        dom.id = 'gradient';
        head.appendChild(dom);
      }
      var left = 'left, ' + this.game.bgColor + ', rgba(0, 0, 0, 0)'
      var right = 'right, ' + this.game.bgColor + ', rgba(0, 0, 0, 0)'

      var text = ''
      text += '.leftGradient{ background:linear-gradient(' + left + ');'
      text += 'background:-webkit-linear-gradient(' + left + ');'
      text += 'background:-moz-linear-gradient(' + left + ');'
      text += 'background:-ms-linear-gradient(' + left + ');'
      text += 'background: -o-linear-gradient(' + left + ');}'
      text += '.rightGradient{ background:linear-gradient(' + right + ');'
      text += 'background:-webkit-linear-gradient(' + right + ');'
      text += 'background:-moz-linear-gradient(' + right + ');'
      text += 'background:-ms-linear-gradient(' + right + ');'
      text += 'background: -o-linear-gradient(' + right + ');}'
      dom.innerHTML = text
      return dom;

    },
    getBanner: function () {
      if (document.getElementById('lottiedesktop')) {
        document.getElementById('lottiedesktop').innerHTML = ''
      }
      if (document.getElementById('lottiemobile')) {
        document.getElementById('lottiemobile').innerHTML = ''
      }
      var _desktop = {
        game: 'aeon bet',
        name: this.$route.params.game,
        type: 'desktop'
      }
      this.$store.dispatch('loadGameAni', {credentials: _desktop}).then((res) => {
        lottie.loadAnimation({
          container: document.getElementById('lottiedesktop'),
          renderer: 'svg',
          loop: true,
          autoplay: true,
          animationData: res.data
        });
        this.desktoploaded = true;
      })
      var _mobile = {
        game: 'aeon bet',
        name: this.$route.params.game,
        type: 'mobile'
      }
      this.$store.dispatch('loadGameAni', {credentials: _mobile}).then((res) => {
        lottie.loadAnimation({
          container: document.getElementById('lottiemobile'),
          renderer: 'svg',
          loop: true,
          autoplay: true,
          animationData: res.data
        });
        this.mobileloaded = true;
      })
    }
  },
  mounted: function () {
    var $this = this
    $this.getWidth()
    $this.getBanner()
    window.onresize = () => {
      return (() => {
        $this.getWidth()
      })()
    }
    this.$bus._events['orientationchange'] = null
    this.$bus.$on('orientationchange', () => {
      $this.getBanner()
    })
  },
  beforeDestroy() {
    this.$bus._events['orientationchange'] = null
    if (this.gamePop !== null) {
      this.gamePop.close();
    }
  },
  watch: {
    'lang': {
      handler: function () {
        if (this.gamePop !== null) {
          this.gamePop.close();
        }
      },
      deep: true,
      immediate: true
    },
    'game': {
      handler: function () {
        this.desktoploaded = false;
        this.mobileloaded = false;
        this.getBanner()
        window.scrollTo(0, 0);
      },
      deep: true,
      immediate: true
    },
    'game.bgColor': {
      handler: function () {
        this.getDomDCSS()
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../style/gameDetail';
</style>
